export default function PhoneIcon({ svgClass }) {
  return (
    <svg
      className={svgClass}
      xmlns='http://www.w3.org/2000/svg'
      width='25.329'
      height='24'
      viewBox='0 0 25.329 24'>
      <path
        id='Logo'
        d='M3.732,0C7.377.539,8.671,3.2,8.6,7.089L6.612,9.857c2.916,4.434,6.075,6.806,9.414,7.643l2.768-3.012c3.045.267,5.5,1.415,6.535,4.673C23.115,33.744-11.146,11.833,3.732,0'
        fill='#fff'
      />
    </svg>
  );
}
